import {Component, Input} from '@angular/core';

import {HelpChangePasswordComponent} from "./components/help-change-password/help-change-password.component";
import {HelpChangeEmailComponent} from "./components/help-change-email/help-change-email.component";
import {HelpChangeUsernameComponent} from "./components/help-change-username/help-change-username.component";
import {
  HelpChangeDefaultAddressComponent
} from "./components/help-change-default-address/help-change-default-address.component";
import {
  HelpVerificationMethodComponent
} from "./components/help-verification-method/help-verification-method.component";
import {
  HelpNotificationSettingsComponent
} from "./components/help-notification-settings/help-notification-settings.component";
import {HelpDeleteAccountComponent} from "./components/help-delete-account/help-delete-account.component";

@Component({
    selector: 'nz-profile-settings',
    imports: [
        HelpChangePasswordComponent,
        HelpChangeEmailComponent,
        HelpChangeUsernameComponent,
        HelpChangeDefaultAddressComponent,
        HelpVerificationMethodComponent,
        HelpNotificationSettingsComponent,
        HelpDeleteAccountComponent
    ],
    templateUrl: './profile-settings.component.html',
    styleUrl: './profile-settings.component.scss'
})
export class ProfileSettingsComponent {
  @Input() subsectionId?: number;
}
